import { useState } from "react";
import { Card, Row, Col, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import Pagination from "components/CommonForBoth/Pagination";

const NotificationsList = ({ notifications = [], handleDeleteNotification }) => {
    const limit = 5;
    const [currentPage, setCurrentPage] = useState(0);
    const [skip, setSkip] = useState(0);

    const totalNotifications = notifications.length;
    const totalPages = Math.ceil(totalNotifications / limit);
    const paginationItems = [...Array(totalPages)];

    const notificationsToShow = notifications.slice(skip, skip + limit);

    const handlePagination = (id) => {
        if (typeof id === "number") {
            setCurrentPage(id);
            setSkip(limit * id);
        } else if (id === "prev" && currentPage > 0) {
            setCurrentPage(currentPage - 1);
            setSkip(skip - limit);
        } else if (id === "next" && currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
            setSkip(skip + limit);
        }
    };

    return (
        <div
            style={{
                backgroundColor: "#F4F4F4",
                fontSize: "20px",
                fontWeight: 400,
                padding: "40px",
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
        >
            {totalNotifications > 0 ? (
                <>
                    {notificationsToShow.map((notif) => (
                        <Card
                            key={notif._id}
                            style={{
                                marginBottom: "30px",
                                backgroundColor: notif.read ? "#FFFFFF" : "#E6F7FF",
                            }}
                        >
                            <Row gutter={[16, 16]} align="middle">
                                <Col span={18}>
                                    <p style={{ margin: 0, fontSize: "18px", fontWeight: 500 }}>
                                        {notif.message}
                                    </p>
                                    <small style={{ color: "#888" }}>
                                        {new Date(notif.createdAt).toLocaleString("fr-FR", {
                                            dateStyle: "medium",
                                            timeStyle: "short",
                                        })}
                                    </small>
                                </Col>
                                <Col span={6} className="d-flex justify-content-end">
                                    {/* <Button
                                        type="text"
                                        icon={<DeleteOutlined />}
                                        onClick={() => handleDeleteNotification(notif._id)}
                                    /> */}
                                </Col>
                            </Row>
                        </Card>
                    ))}

                    <div style={{ width: "fit-content", margin: "0 auto" }}>
                        <Pagination
                            pages={paginationItems}
                            totalItems={totalNotifications}
                            handlePagesnation={handlePagination}
                            currentPage={currentPage}
                            limit={limit}
                        />
                    </div>
                </>
            ) : (
                <div className="text-center py-5">
                    <p>Aucune notification disponible.</p>
                </div>
            )}
        </div>
    );
};

export default NotificationsList;
